<template>
    <div>
        <div
            v-if="!isMobileLogin()"
            class="text-white bg-gray-500 text-center text-xs py-3 md:py-5 px-3 md:mb-0"
            :class="{'relative z-1000': $route.name===routeName.ENOTIFY}"
        >
            <div class="pb-2">
                <a
                    class="text-base underline"
                    @click="toCustomerService"
                >
                    客服中心
                </a>
            </div>
            建議瀏覽器版本：<span class="whitespace-nowrap">最新版本Chrome、Firefox、Safari、Edge</span>
            <br>© Fubon Life Insurance Co. Ltd. All Rights Reserved
        </div>
        <div
            class="bg-gray-500 md:hidden"
            :style="{'padding-bottom':`${paddingbottom}px`}"
        />
    </div>
    <!-- footer end-->
</template>
<script>
import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { isMobileLogin } from '@/utils/is';
import routeName from '@/router/constant.js';

export default {
    name: 'Footer',
    setup() {
        const store = useStore();
        const route = useRoute();
        const paddingbottom = computed(() => {
            return store.state.layout.bottomPadding;
        });

        const toCustomerService = () => {
            window.open(process.env.VUE_APP_CUSTOMER_SERVICE_RUL);
        };

        watch(() => route.name, (nV, oV) => {
        }, { immediate: true });

        return {
            isMobileLogin,
            paddingbottom,
            toCustomerService,
            routeName,
        };
    },
};
</script>
